import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Main = () => {
  const navigate = useNavigate();
  const originalConsoleError = console.error;

  console.error = (...args) => {
    const message = args[0];
    if (
      typeof message === 'string' &&
      message.includes('ResizeObserver loop')
    ) {
      // Blokuj wyświetlanie overlayu
      return;
    }
    originalConsoleError(...args);
  };
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        const y = el.getBoundingClientRect().top + window.pageYOffset - 60;
        window.scrollTo({ top: y, behavior: 'smooth' });
        // el.scrollIntoView({
        //   behavior: 'smooth',
        // });
      }
    }
  }, [hash]);
  return (
    <div>
      <section
        id="main"
        className="relative bg-gray-900 bg-cover bg-left bg-no-repeat h-80 w-full p-6 flex items-center img2"
        // style={{ backgroundImage: "url('/3.jpg')" }}
      >
        <div className="relative max-w-4xl mx-auto w-full h-full flex  md:flex-row items-center md:items-start ">
          {/* Tekst */}
          <div class="md:w-1/2"></div>
          <div className="relative  z-10 w-full md:w-1/2 text-center md:text-left px-6 mt-8">
            <h2 class="text-xl md:text-3xl font-bold md:text-white mb-2">
              Trener Personalny Piotr Bojanowski
            </h2>
            <h1 class="text-3xl md:text-4xl font-bold text-gray-400 leading-tight mt-8">
              Współpraca z trenerem w Łodzi <br /> oraz online
            </h1>
          </div>
          {/* Zdjęcie */}
        </div>
      </section>
      <section id="o-mnie" class="bg-gray-800 p-6 fade-in">
        <div class="max-w-4xl mx-auto">
          <h2 class="text-3xl font-bold mb-4">O mnie</h2>
          <div class="md:flex gap-6 items-center">
            <img
              src="2.jpg"
              alt="trener"
              class="w-full md:w-1/3 rounded-xl mb-4 md:mb-0"
            />
            <div>
              <p class="text-gray-300 mb-4">
                Jestem certyfikowanym trenerem personalnym, który pasję do
                sportu odkrywał od najmłodszych lat. Rozpoczynałem od sportów
                zespołowych i biegania, jednakże z czasem trening na siłowni
                stał się nieodłączną częścią mojego życia. Teraz, dzięki mojej
                wiedzy i doświadczeniu, pomagam klientom osiągać swoje cele,
                dostosowując treningi do ich indywidualnych potrzeb i
                możliwości. Stale rozwijam swoje umiejętności z wiedzy z zakresu
                treningu i dietetyki, aby zapewnić moim klientom najwyższy
                poziom wsparcia i skutecznych rezultatów.
              </p>
              <h3 class="text-xl font-semibold mb-2">Dlaczego warto?</h3>
              <ul class="list-disc pl-6 text-gray-400">
                <li>
                  <b>Indywidualne podejście</b> - Każdy plan dostosowuję do
                  Twoich możliwości, celów i stylu życia.
                </li>
                <li>
                  <b>Sprawdzone metody</b> - Każde zalecenie opieram na
                  sprawdzonych metodach, praktyce i aktualnej wiedzy o ciele i
                  odżywianiu.
                </li>
                <li>
                  <b>Stały kontakt i wsparcie </b>- Nie zostawiam Cię z planem
                  „na papierze”. Masz moje pełne wsparcie i motywację na każdym
                  kroku.
                </li>
                <li>
                  <b>Bezpieczny progres</b> - Trenujesz skutecznie, ale mądrze –
                  z zachowaniem techniki, zdrowia i regeneracji.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Co ze mną osiągniesz --> */}
      <section id="co-ze-mna-osiagniesz" class="max-w-4xl mx-auto p-6 fade-in">
        <h2 class="text-3xl font-bold mb-6 text-center text-white">
          Co ze mną osiągniesz?
        </h2>
        <div class="space-y-6">
          <div class="flex items-start space-x-4">
            <i class="ph ph-check-circle text-4xl text-green-400"></i>
            <p class="text-lg text-gray-300 leading-relaxed">
              <b>Wymarzona sylwetka</b> – Bez presji, bez drastycznych diet, za
              to z planem, który działa. Pomogę Ci zbudować sylwetkę, z której
              będziesz dumny/a, niezależnie od tego, czy chcesz schudnąć,
              wyrzeźbić ciało, czy po prostu wyglądać i czuć się lepiej.
            </p>
          </div>
          <div class="flex items-start space-x-4">
            <i class="ph ph-check-circle text-4xl text-green-400"></i>
            <p class="text-lg text-gray-300 leading-relaxed">
              <b>Poprawa zdrowia fizycznego </b>– Regularne treningi i dobre
              nawyki żywieniowe pozwolą Ci zredukować ryzyko chorób
              cywilizacyjnych, takich jak cukrzyca, nadciśnienie, otyłość czy
              problemy z kręgosłupem. To inwestycja w Twoje zdrowie – teraz i na
              przyszłość.
            </p>
          </div>
          <div class="flex items-start space-x-4">
            <i class="ph ph-check-circle text-4xl text-green-400"></i>
            <p class="text-lg text-gray-300 leading-relaxed">
              <b>Zdrowie psychiczne</b> – Trening to najlepszy sposób na
              odreagowanie stresu, poprawę nastroju i wzmocnienie psychiki.
              Zadbamy o Twój balans – nie tylko fizyczny, ale i mentalny.
            </p>
          </div>
          <div class="flex items-start space-x-4">
            <i class="ph ph-check-circle text-4xl text-green-400"></i>
            <p class="text-lg text-gray-300 leading-relaxed">
              <b>Więcej energii i lepsze samopoczucie </b>– Zamiast ciągłego
              zmęczenia – motywacja, siła i jasny umysł. Regularna aktywność
              wpływa na sen, trawienie, koncentrację i ogólne funkcjonowanie
              organizmu.
            </p>
          </div>
          <div class="flex items-start space-x-4">
            <i class="ph ph-check-circle text-4xl text-green-400"></i>
            <p class="text-lg text-gray-300 leading-relaxed">
              <b>Większa pewność siebie i pozytywne nastawienie</b> – Każdy
              progres to krok do lepszej wersji siebie – nie tylko fizycznie.
              Zmienisz swoje podejście do ciała, do treningu i… do życia.
            </p>
          </div>
          <div class="flex items-start space-x-4">
            <i class="ph ph-check-circle text-4xl text-green-400"></i>
            <p class="text-lg text-gray-300 leading-relaxed">
              <b>Trwała zmiana stylu życia</b> – Razem stworzymy fundamenty pod
              styl życia, który będzie wspierał Twoje zdrowie i formę przez
              lata. To nie chwilowy zryw – to długoterminowa zmiana na lepsze.
            </p>
          </div>
        </div>
      </section>
      {/* <!-- Oferta --> */}

      <section id="oferta" class="bg-gray-800 p-6 fade-in">
        <div class="max-w-4xl mx-auto">
          <h2 class="text-3xl font-bold mb-4">Oferta + Cennik</h2>
          <div class="grid gap-4 md:grid-cols-2 text-gray-300">
            {/* <div class="bg-gray-700 p-4 rounded-xl shadow-lg hover:bg-gray-600 transition-colors duration-300">
                <h3 class="text-xl font-semibold">SOLO</h3>
                <p>
                  - Trenujemy w komfortowych warunkach w VeraSport Łódź
                  Indywidualny plan treningowy – dopasowany do Twojego celu,
                  poziomu i możliwości <br />
                  - Szczegółowa ankieta wstępna – poznaję Twoje potrzeby, styl
                  życia i ograniczenia <br />
                  - Pomogę Ci uporządkować nawyki żywieniowe i dobrać
                  odpowiednią suplementację – bez zbędnych skomplikowanych zasad
                  <br /> - Stały kontakt i feedback – nie zostawiam Cię samego
                  między treningami <br />- Bez oceniania, z pełnym
                  zaangażowaniem – atmosfera współpracy, nie presji <br />-
                  Pierwsze spotkanie w formie konsultacji – sprawdzimy, czy to
                  coś dla Ciebie
                </p>
                 <p class="text-lg font-bold mt-2">Cena: 130 zł</p> 
              </div> */}
            <div
              className="bg-gray-700 rounded-2xl p-6 shadow-xl text-white max-w-2xl w-full cursor-pointer"
              onClick={() => navigate('/solo')}
            >
              <h3 className="text-2xl font-extrabold mb-4 border-b border-gray-600 pb-2">
                SOLO
              </h3>
              <div className="space-y-4 text-sm md:text-base">
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>Trenujemy w komfortowych warunkach w VeraSport Łódź</p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Indywidualny plan treningowy dopasowany do Twojego celu,
                    poziomu i możliwości
                  </p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Szczegółowa ankieta wstępna – poznaję Twoje potrzeby, styl
                    życia i ograniczenia
                  </p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Pomoc w uporządkowaniu nawyków żywieniowych i doborze
                    suplementacji – bez zbędnych zasad
                  </p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Stały kontakt i feedback – jesteśmy w kontakcie między
                    treningami
                  </p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Bez oceniania, z pełnym zaangażowaniem – partnerska
                    atmosfera, zero presji
                  </p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Pierwsze spotkanie jako konsultacja – sprawdzimy, czy to coś
                    dla Ciebie
                  </p>
                </div>
              </div>
            </div>

            <div
              className="bg-gray-700 rounded-2xl p-6 shadow-xl text-white max-w-2xl w-full cursor-pointer"
              onClick={() => navigate('/duo')}
            >
              <h3 className="text-2xl font-extrabold mb-4 border-b border-gray-600 pb-2">
                DUO
              </h3>
              <div className="space-y-4 text-sm md:text-base">
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>Trenujemy w komfortowych warunkach w VeraSport Łódź</p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Plan treningowy dopasowany do Waszego poziomu i celów –
                    nawet jeśli się różnicie
                  </p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Wspólna ankieta wstępna – poznaję Wasze potrzeby, styl życia
                    i oczekiwania
                  </p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Pomoc w ogarnięciu diety i suplementacji – dostosowana do
                    każdej osoby
                  </p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Stały kontakt i wsparcie między treningami – razem i osobno,
                    jeśli trzeba
                  </p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Motywacja x2 – trenujecie razem, ale każdy rozwija się we
                    własnym tempie
                  </p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Luźna, wspierająca atmosfera – zero rywalizacji, 100%
                    współpracy
                  </p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Pierwsze spotkanie w formie konsultacji – sprawdzimy, jak
                    się razem odnajdujecie
                  </p>
                </div>
              </div>
            </div>

            <div
              className="bg-gray-700 rounded-2xl p-6 shadow-xl text-white max-w-2xl w-full cursor-pointer"
              onClick={() => navigate('/online')}
            >
              <h3 className="text-2xl font-extrabold mb-4 border-b border-gray-600 pb-2">
                ONLINE
              </h3>
              <div className="space-y-4 text-sm md:text-base">
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Plan treningowy dopasowany do Ciebie – bez względu na to,
                    czy ćwiczysz w domu, na siłowni czy plenerze
                  </p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Szczegółowa ankieta startowa – poznaję Twoje cele,
                    ograniczenia, tryb życia
                  </p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Wskazówki żywieniowe i suplementacja – bez skrajności, z
                    nastawieniem na trwałe zmiany
                  </p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Stały kontakt i regularny feedback -jesteśmy w kontakcie na
                    bieżąco
                  </p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Monitoruję Twoje postępy i modyfikuję plan – reaguję na
                    bieżąco, Ty nie działasz w ciemno
                  </p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Wspierająca relacja bez oceniania – dostosowuję się do
                    Ciebie, nie odwrotnie
                  </p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Dodatkowe materiały, tipy i motywacja – nie tylko rozpiska,
                    ale i realne wsparcie
                  </p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Pierwsza konsultacja online – poznajemy się i ustalamy plan
                    działania
                  </p>
                </div>
              </div>
            </div>

            <div
              className="bg-gray-700 rounded-2xl p-6 shadow-xl text-white max-w-2xl w-full cursor-pointer"
              onClick={() => navigate('/plan')}
            >
              <h3 className="text-2xl font-extrabold mb-4 border-b border-gray-600 pb-2">
                PLAN TRENINGOWY
              </h3>
              <div className="space-y-4 text-sm md:text-base">
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Plan dopasowany do Twojego celu, poziomu i stylu życia – bez
                    gotowców i kopiuj-wklej
                  </p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Ćwiczysz tam, gdzie chcesz – siłownia, dom, plener –
                    wszystko uwzględniam
                  </p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Szczegółowa ankieta startowa – żeby plan był naprawdę Twój
                  </p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Wskazówki żywieniowe i suplementacyjne – jeśli chcesz,
                    dostajesz pełne wsparcie
                  </p>
                </div>
                <div className="flex gap-3">
                  <span className="text-blue-400">✓</span>
                  <p>
                    Czytelna rozpiska z dokładnymi instrukcjami – zero domysłów,
                    wszystko podane jasno
                  </p>
                </div>
              </div>
            </div>

            {/* <div class="bg-gray-700 p-4 rounded-xl shadow-lg hover:bg-gray-600 transition-colors duration-300">
              <h3 class="text-xl font-semibold">Plan treningowy</h3>
              <p>Plan z filmikami i instrukcjami.</p>
              <p class="text-lg font-bold mt-2">Cena: 150 zł</p>
            </div> */}
            {/* <div class="bg-gray-700 p-4 rounded-xl shadow-lg col-span-full hover:bg-gray-600 transition-colors duration-300">
              <h3 class="text-xl font-semibold">Plan dietetyczny</h3>
              <p>Stworzony z dietetykiem, pyszne przepisy i elastyczność.</p>
              <p class="text-lg font-bold mt-2">Cena: 200 zł</p>
            </div> */}
          </div>
        </div>
      </section>
      {/* <!-- Opinie --> */}

      {/* <!-- Kontakt --> */}
    </div>
  );
};

export default Main;
